module.exports = __webpack_public_path__ + "images/file_icons_v2/csv-175dcb3656a07d2d835a96467ff0783d.svg";